import { useAuth0 } from "@auth0/auth0-react";
// import { useEffect, useState } from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import LoginHeader from "../components/header/LoginHeader";
// import Loader from "../components/Loader";
import { post } from "../services/api";
import Cookies from "universal-cookie";
import { isStoreDevice } from "../admin/useCurrentUser";
import { maintenanceSignIn } from "../admin/screens/maintenance/maintenanceSignIn";
// import { exit } from "process";

const Login: React.FC = () => {
  const [searchParams] = useSearchParams();
  // console.log("searchParams = ", searchParams)
  // const [appLogin, setAppLogin] = useState<boolean>(false);

  const {
    loginWithRedirect,
    isAuthenticated,
    getIdTokenClaims,
    getAccessTokenSilently,
    user,
    logout,
    // isLoading,
  } = useAuth0();

  // debugger;

  const email = searchParams.get("email");
  const invite = searchParams.get("invite");
  const error = searchParams.get("error");
  // console.log("+Login: email, invite, isAuthenticated, user, error = ", email, invite, isAuthenticated, user, error);

  useEffect(() => {
    console.log(
      "login.tsx: useEffect 1: email, invite, isAuthenticated, user, error = ",
      email,
      invite,
      isAuthenticated,
      user,
      error
    );
    if (email && invite) {
      if (isAuthenticated && user) {
        loginWithRedirect({authorizationParams: {
          screen_hint: "signup",
          login_hint: email,
        }})
      }
    }
    console.log("useEffect1: Returning")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, invite]);

  useEffect(() => {
    // console.log("Login: useEffect2: isAuthenticated, user, error = ", isAuthenticated, user, error)
    
    if(error==="access_denied"){
      // Sleep for 5 seconds before redirecting to the login page
      setTimeout(()=>{
        logout()
       }, 5000)
      return;
    }
    if (isAuthenticated && user) {
      console.log("Login: calling setAppLogin(true)")
      // setAppLogin(true);
      const { email, email_verified, name, picture } = user;
      console.log("Login: email, email_verified, picture = ", email, email_verified, picture)
      // A maintenance-only account (role 11, read from its access token) signs in
      // through GET /maintenance/session instead of POST /user. Every other
      // role, and any failure to read the role, continues exactly as before.
      maintenanceSignIn({ getAccessTokenSilently, getIdTokenClaims, user, logout }).then((handled) => {
      if (handled) return;
      getIdTokenClaims().then((res) => {
        console.log("Login: getIdTokenClaims done. calling post user")
        getAccessTokenSilently().then((userToken: any) => post(`user`, { email, email_verified, name, picture }, userToken)).then(
          (response: any) => {
            // setUserId(response.payload.data.user_id);
            if (!response.payload.data.user_id) {
              console.log("Clearing local storage...")
              // setAppLogin(false);
              localStorage.clear();
              logout();
              return;
            }
            // setAppLogin(false);

            console.log("Calling getAccessTokenSilently");
            // Set cookie
            getAccessTokenSilently().then((result: any) => {
              const accessTokenVal = result;
              const cookies = new Cookies();
              cookies.set(
                process.env.REACT_APP_AUTH0_COOKIE_NAME || "",
                accessTokenVal,
                { domain: ".paperlessnow.ca", path: "/", maxAge: 7 * 24 * 60 * 60, secure: true, sameSite: "lax" } // Expires in 7 days; HTTPS only
              );

              const userInfoVal = {
                ...response.payload.data,
                // Keep stable display claims with the app session so admin
                // chrome does not depend on Auth0's in-memory hydration timing.
                name: name || response.payload.data.name,
                email: email || response.payload.data.email,
                picture: picture || response.payload.data.picture,
                idToken: res?.__raw,
                accessToken: accessTokenVal,
              };


              localStorage.setItem("userInfo", JSON.stringify(userInfoVal));

              getIdTokenClaims().then((result: any) => {
                const expiresAt = JSON.stringify(result.exp * 1000);
                localStorage.setItem("expiresAt", expiresAt);
                // The counter tablet (store device) only has Work Orders.
                const landing = isStoreDevice(userInfoVal) ? "/work-orders" : "/dashboard";
                window.location.href = window.location.origin + landing;
              });
            })
            .catch(e => {
              console.debug('Error getAccessTokenSilently fetching access token', e.message)
            });;
          }
        );
      })
      .catch(e => {
        console.debug('Error fetching access token', e.message)
      });
      });
    } else {
      console.log(
        "login.tsx: useEffect: else: email, invite = ",
        email,
        invite
      );
      if (email && invite) {
        loginWithRedirect({authorizationParams: {
          screen_hint: "signup",
          login_hint: email,
        }})
      } 
      else {
        console.log("login.tsx: useEffect: else->else. calling loginWithRedirect");
        loginWithRedirect({
        //   screen_hint: "signup",
        });
        console.log("loginWithRedirect returned")
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isAuthenticated]);

  function checkExistingUser() {
    console.log("checkExistingUser. error = ", error);
    if (error) {
      console.log("checkExistingUser: error. calling login with redirect");
      loginWithRedirect();
    } else {
      console.log(
        "checkExistingUser: success: user, isAuthenticated = ",
        user,
        isAuthenticated
      );
      if (user && isAuthenticated) loginWithRedirect();
    }
    console.log("checkExistingUser. returning error = ", error)
  }

  console.log("login.tsx: calling return 1...")
  return (
    <body onLoad={() => checkExistingUser()}>
      {error ? (
        <div className="container-scroller ">
          <div className="container-fluid page-body-wrapper full-page-wrapper">
            <div className="content-wrapper d-flex align-items-center auth px-0 login-background">
              <div className="row w-100 mx-0">
                <div className="col-lg-4 mx-auto">
                  <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                    <b>
                      We are unable to find your account details. Please contact
                      us at hello@paperlessnow.ca to create an account for your
                      organization.
                    </b>
                    <br /><br />
                    <i>
                      Redirecting to the login page in 5 seconds...
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </body>
  );

  // return (
  //   <body onLoad={() => checkExistingUser()}>
  //  {/* <body>  */}
  //   <div>
  //     {/* <LoginHeader /> */}

  //     <div className="container-scroller ">
  //       <div className="container-fluid page-body-wrapper full-page-wrapper">
  //         <div className="content-wrapper d-flex align-items-center auth px-0 login-background">
  //           <div className="row w-100 mx-0">
  //             <div className="col-lg-4 mx-auto">
  //               <div className="auth-form-light text-left py-5 px-4 px-sm-5">

  //                     {error ? (
  //                       <b>We are unable to find your account details. Please contact us at hello@paperlessnow.ca to create an account for your organization</b>

  //                     ) : (
  //                       // <>
  //                       <h5 className="signintext">
  //                   <span>
  //                     <b>Loading ...</b>
  //                         </span>
  //                 </h5>
  //                       // </>
  //                     )}

  //                 {/* <h6 className="font-weight-light subheading-email">
  //                       Email or mobile number
  //                     </h6> */}
  //                 <form>
  //                   {/* <div className="form-group">
  //                         <input
  //                           type="email"
  //                           className="form-control form-control-lg login-email-input"
  //                           id="exampleInputEmail1"
  //                           placeholder="Enter"
  //                         />
  //                       </div> */}

  //                   <div className="mt-3">
  //                     {/* <a
  //                           className="btn btn-block btn-lg font-weight-medium login-button-background"
  //                           // onClick={() => loginWithRedirect()}
  //                           href="/dashboard"
  //                         >
  //                           Next
  //                         </a> */}
  //                     {isLoading || appLogin ? (
  //                       <Loader />
  //                     ) :
  //                     (

  //                         // <button
  //                         //   className="btn btn-block btn-lg font-weight-medium login-button-background"
  //                         //   onClick={() => loginWithRedirect()}
  //                         // >
  //                         //   Login
  //                         // </button>
  //                         null

  //                      )

  //                     }
  //                   </div>
  //                   {/* <div className="form-check-label-no-account">
  //                         <label>
  //                           Don't have an account?{" "}
  //                           <a
  //                             href="/"
  //                             className="auth-link text-black "
  //                             style={{ color: "#0CB99D" }}
  //                           >
  //                             Sign Up
  //                           </a>
  //                         </label>
  //                       </div> */}
  //                   {/* <div className="mt-2 mb-2 text-center text-between-lines">
  //                         or
  //                       </div> */}
  //                   {/* <div className="mb-2">
  //                         <button type="button" className="btn social-sign-button">
  //                           <svg
  //                             viewBox="0 0 24 24"
  //                             width="24"
  //                             height="24"
  //                             xmlns="http://www.w3.org/2000/svg"
  //                           >
  //                             <g transform="matrix(1, 0, 0, 1, 27.009001, -39.238998)">
  //                               <path
  //                                 fill="#4285F4"
  //                                 d="M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.229 -9.424 56.479 -10.684 57.329 L -10.684 60.329 L -6.824 60.329 C -4.564 58.239 -3.264 55.159 -3.264 51.509 Z"
  //                               />
  //                               <path
  //                                 fill="#34A853"
  //                                 d="M -14.754 63.239 C -11.514 63.239 -8.804 62.159 -6.824 60.329 L -10.684 57.329 C -11.764 58.049 -13.134 58.489 -14.754 58.489 C -17.884 58.489 -20.534 56.379 -21.484 53.529 L -25.464 53.529 L -25.464 56.619 C -23.494 60.539 -19.444 63.239 -14.754 63.239 Z"
  //                               />
  //                               <path
  //                                 fill="#FBBC05"
  //                                 d="M -21.484 53.529 C -21.734 52.809 -21.864 52.039 -21.864 51.239 C -21.864 50.439 -21.724 49.669 -21.484 48.949 L -21.484 45.859 L -25.464 45.859 C -26.284 47.479 -26.754 49.299 -26.754 51.239 C -26.754 53.179 -26.284 54.999 -25.464 56.619 L -21.484 53.529 Z"
  //                               />
  //                               <path
  //                                 fill="#EA4335"
  //                                 d="M -14.754 43.989 C -12.984 43.989 -11.404 44.599 -10.154 45.789 L -6.734 42.369 C -8.804 40.429 -11.514 39.239 -14.754 39.239 C -19.444 39.239 -23.494 41.939 -25.464 45.859 L -21.484 48.949 C -20.534 46.099 -17.884 43.989 -14.754 43.989 Z"
  //                               />
  //                             </g>
  //                           </svg>{" "}
  //                           Sign in with Google
  //                         </button>
  //                       </div> */}
  //                   {/* <div className="mb-2">
  //                         <button
  //                           // type="button social-sign-"
  //                           className="btn social-sign-button"
  //                         >
  //                           <svg
  //                             xmlns="http://www.w3.org/2000/svg"
  //                             width="24"
  //                             height="24"
  //                             viewBox="0 0 14222 14222"
  //                           >
  //                             <circle cx="7111" cy="7112" r="7111" fill="#1977f3" />
  //                             <path
  //                               d="M9879 9168l315-2056H8222V5778c0-562 275-1111 1159-1111h897V2917s-814-139-1592-139c-1624 0-2686 984-2686 2767v1567H4194v2056h1806v4969c362 57 733 86 1111 86s749-30 1111-86V9168z"
  //                               fill="#fff"
  //                             />
  //                           </svg>{" "}
  //                           Sign in with Facebook
  //                         </button>
  //                       </div> */}
  //                 </form>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>

  //     {/* <div className="login-background-image"></div> */}
  //   </div>
  //   </body>
  // );
};

export default Login;


/*
Useful links
https://thinkster.io/tutorials/auth0-react-login-and-user-profile/protect-the-profile-route
*/
